import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { InfoControl } from '../../RIValidation/components/InfoControl';
import { ContratosPaciente } from '../../RIValidation/components/ContratosPaciente';
import { DireccionContent } from "../../RIValidation/components/DireccionContent";
import { AptoInput } from "../../RIValidation/components/AptoInput";
import { useGetActions } from "../hooks/useGetActions";
import { ConfirmarEquipoInput } from "../ConfirmarEquipo/ConfirmarEquipo";
import { CambioProgramaInput } from "../../RIAsignacion/components/CambioProgramaInput";
import InformacionEquipo from "../../RIValidation/components/InformacionEquipo";

export const RIConfirmarEquipoContent = ({ setChildrenAction }) => {
    const location = useLocation();
    const stateData = location.state;
    const { notificationData, tipoNotificacion, idDelegacion, idTipoModulo } = stateData;
    const [notification, setNotification] = useState(notificationData || {});
    const [apto, setApto] = useState(false);
    const [contratosIds, setContratosIds] = useState([]);

    const handleChange = (name, value) => {
        setNotification(prevDatos => ({
            ...prevDatos,
            [name]: value
        }));
    }

    const {
        handleClickValidar,
        handleClickArmarEquipo,
        handleClickCambiarPrograma,
        loading: buttonActionLoading
    } = useGetActions({ handleChange, notification });


    useEffect(() => {
        if (!notification) return setChildrenAction(null);

        setChildrenAction(() => (
            (notification.estadoValidacion !== 'Validado' && <div className='top-buttons'>
                {/* hacer version de aptoInput para cambio programa */}
                {notification.estadoCoordinador != 'Correccion' && <div className='margin-right'>
                    <CambioProgramaInput
                        disabled={notification?.hasMultiplePrograms}
                        idEvaluacion={notification?.idEvaluacion}
                        loadingOthersButtons={buttonActionLoading}
                        handleClickAceptar={() => handleClickCambiarPrograma()}
                    />
                </div>}
                <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                        loadingValidar={buttonActionLoading}
                        isReject={true}
                    />
                </div>
                <div className='margin-right'>
                    <ConfirmarEquipoInput
                        idDelegacion={idDelegacion}
                        idEvaluacion={notification?.idEvaluacion}
                        otherButtonsLoading={buttonActionLoading}
                        handleClickAceptar={handleClickArmarEquipo}
                    />
                </div>
                {/* <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        loadingValidar={buttonActionLoading}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                    />
                </div> */}
            </div>)
        ))
    }, [notification, buttonActionLoading, apto]);

    return <>
        <InfoControl
            notification={notification}
            tipoNotificacion={tipoNotificacion}
        />
        <DireccionContent
            notification={notification}
            setApto={setApto}
        />
        <InformacionEquipo
            idEvaluacion={notification?.idEvaluacion}
        />
        <ContratosPaciente
            idPaciente={notification?.hC}
            setContratosIds={setContratosIds}
        />
    </>
}